@let isListExpanded = userSettingsStore.usersListExpanded$ | async;
@let ownUser = userService.ownUser();
@let overlayHeights = roomOverlayHeights();
@if (ownUser) {
  <div
    class="users-list {{ isListExpanded ? 'expanded' : '' }}"
    [style.--list-item-height]="itemSize + 'px'">
    <cdk-virtual-scroll-viewport
      class="scroll-viewport"
      [minBufferPx]="300"
      [maxBufferPx]="600"
      [itemSize]="itemSize">
      <ng-container *cdkVirtualFor="let item of flattenedItems(); trackBy: trackByItem">
        @if (item.type === 'header') {
          @let isActive = ownUser.data.breakoutRoomId === item.roomId;
          @let suppressOverlay = lastBreakoutRoomId() === item.roomId;
          <div
            class="room-header"
            [attr.data-room-id]="item.roomId"
            [class.active]="isActive"
            [class.other-room]="!isActive"
            [class.suppress-overlay]="suppressOverlay"
            (click)="!isActive && joinBreakoutRoom(item.roomId)"
            (mouseleave)="lastBreakoutRoomId.set(null)">
            @if (isListExpanded) {
              <fa-duotone-icon [icon]="faHashtag" primaryOpacity="0.6"></fa-duotone-icon>
              <span class="room-header-text">{{ item.roomId }}</span>
            }
            @if (isActive) {
              <fa-duotone-icon
                class="room-header-action"
                [icon]="faArrowRightFromArc"
                [andorTooltip]="'Leave Room' | translate"
                (click)="
                  leaveBreakoutRoom(item.roomId); $event.stopPropagation()
                "></fa-duotone-icon>
            } @else {
              <fa-duotone-icon
                class="room-header-action"
                [icon]="faArrowLeftToArc"
                [andorTooltip]="'Join Room' | translate"
                (click)="joinBreakoutRoom(item.roomId); $event.stopPropagation()"></fa-duotone-icon>
            }
            @if (!isActive && !suppressOverlay) {
              <div
                class="room-join-overlay"
                [style.height.px]="overlayHeights.get(item.roomId) ?? itemSize"
                (click)="joinBreakoutRoom(item.roomId)">
                <span>
                  <fa-duotone-icon class="accent" [icon]="faArrowLeftToArc"></fa-duotone-icon>
                  @if (isListExpanded) {
                    <br />
                    {{ 'Click to join' | translate }}
                  }
                </span>
              </div>
            }
          </div>
        }
        @if (item.type === 'user') {
          <andor-user-entry
            [user]="item.user"
            [class.breakout]="item.user.data.breakoutRoomId !== ''"
            [class.other-room]="item.user.data.breakoutRoomId !== ownUser.data.breakoutRoomId"
            [showTooltip]="!isListExpanded"></andor-user-entry>
        }
      </ng-container>
    </cdk-virtual-scroll-viewport>
  </div>
}
